package game

import com.soywiz.korio.file.VfsFile
import com.soywiz.korio.file.std.applicationDataVfs
import com.soywiz.korio.file.std.localVfs
import com.soywiz.korio.lang.Environment
import com.soywiz.korio.lang.expand
import com.soywiz.korio.util.OS

suspend fun getFile(fileName: String): VfsFile? {
    return try {
        when {
            OS.isJsBrowser -> applicationDataVfs[fileName]
            else -> localVfs(Environment.expand("~/.wishlair")).also { it.mkdir() }.jail()[fileName]
        }
    } catch (e: Exception) {
        println(e)

        null
    }
}

suspend fun fileExists(fileName: String): Boolean = getFile(fileName)?.exists() == false
suspend fun loadFile(fileName: String): String? = getFile(fileName)?.takeIfExists()?.readString()
suspend fun saveFile(fileName: String, data: String): Unit {
    getFile(fileName)?.writeString(data)
}

suspend fun deleteFile(fileName: String): Unit {
    getFile(fileName)?.delete()
}
